<template>
  <div id="whale-backtester-exit-rules-tab">
    <helpers-section-header class="mt-0 mb-6">
      When to exit out of a position:
    </helpers-section-header>

    <v-tabs v-model="tab">
      <v-tab value="1"> Long Positions </v-tab>
      <v-tab v-if="short" value="2"> Short Positions </v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="1">
        <exit-rule-raw rule-type="long" />
      </v-tabs-window-item>
      <v-tabs-window-item v-if="short" value="2">
        <exit-rule-raw rule-type="short" />
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'
import { markRaw } from 'vue'

// Components
import ExitRule from '@/components/page/whale-backtester/_ExitRule'
const ExitRuleRaw = markRaw(ExitRule)
export default {
  components: {
    ExitRuleRaw
  },
  data() {
    return {
      short: false,
      tab: '1'
    }
  },
  computed: {
    ...mapFields({
      criteria: 'app.whaleTraderCriteria'
    })
  }
}
</script>
